<template>
  <div
    style="height: 100%"
  >
    <CustomTableByValueVertical
      v-if="tableType === 'vertical'"
      :aggregation-column="aggregationColumn"
      :columns="columns"
      :data="data"
      :loading="loading"
      :header-column="headerColumn"
      :additional-header-column="additionalHeaderColumn"
      :additional-columns="additionalColumns"
      :group-by="groupBy"
      :border="border"
      :stripe="stripe"
      :scroll="scroll"
      :no-data-text="noDataText"
      :max-height="maxHeight"
      :chart="chart"
      :styles="styles"
    />
    <CustomTableByValueHorizontal
      v-else-if="tableType === 'horizontal'"
      :aggregation-column="aggregationColumn"
      :columns="columns"
      :data="data"
      :loading="loading"
      :header-column="headerColumn"
      :additional-header-column="additionalHeaderColumn"
      :additional-columns="additionalColumns"
      :group-by="groupBy"
      :border="border"
      :stripe="stripe"
      :scroll="scroll"
      :no-data-text="noDataText"
      :max-height="maxHeight"
      :chart="chart"
      :styles="styles"
    />
  </div>
</template>

<script>
import CustomTableByValueHorizontal from '@/components/helper-components/dashboard-components/CustomTableByValueHorizontal'
import CustomTableByValueVertical from '@/components/helper-components/dashboard-components/CustomTableByValueVertical'
import CustomTableByValueMixin from '@/mixins/custom-table-by-value-mixin'

export default {
  components: {
    CustomTableByValueHorizontal,
    CustomTableByValueVertical
  },

  mixins: [
    CustomTableByValueMixin
  ],

  props: {
    tableType: {
      type: String,
      enum: ['vertical', 'horizontal'],
      default: 'vertical'
    }
  }
}
</script>
